export enum CpfFormStatus {
  Pending = 'PENDING_APPLICANT',
  CompletedForm = 'COMPLETED_FORM',
  CpfSent = 'CPF_SENT',
  CpfResent = 'CPF_RESENT',
  CpfRejected = 'CPF_REJECTED',
  CpfAccepted = 'CPF_ACCEPTED',
  RefundRequired = 'REFUND_REQUIRED',
}
